import { StyleSheet } from 'react-native'
import { useTranslation } from 'react-i18next'
import { useUser } from 'zens-store'
import { BreadcrumbData, PageHeaderProps } from 'zens-storybook'
import { useBreadcrumb } from '@dms/hook'

import { LayoutHeader } from '../layout'
const styles = StyleSheet.create({
  container: {},
})

interface Props extends PageHeaderProps {
  companyId: number
  userId: number
  breadcrumbItems?: BreadcrumbData[]
}

const UserHeader = (props: Props) => {
  const { companyId, userId, breadcrumbItems, style, ...otherProps } = props
  const { t } = useTranslation()
  const user = useUser({ companyId, userId })

  const breadcrumb = useBreadcrumb([
    {
      title: t('Users'),
      href: `/companies/${companyId}/users`,
    },
    {
      title: `${user.data?.displayName}`,
      href: `/companies/${companyId}/users/${userId}`,
    },
    ...(breadcrumbItems || []),
  ])

  return (
    <LayoutHeader
      style={[styles.container, style]}
      breadcrumb={breadcrumb}
      title={user.data?.displayName}
      {...otherProps}
    />
  )
}

export default UserHeader
